<div class="c-dashboard">
  <header
    class="c-header"
    app-header
    [isSidebarOpen]="isSidebarOpen()"
    (handleToggle)="isSidebarOpen.set($event)"
  ></header>
  <nav
    class="c-nav"
    app-sidebar
    [isSidebarOpen]="isSidebarOpen()"
    (handleToggle)="isSidebarOpen.set($event)"
    [menu]="menu()"
    [ngClass]="{ 'c-nav--toggled': !isSidebarOpen() }"
  ></nav>
  <main
    class="c-dashboard__main"
    [ngClass]="{ 'c-dashboard__main--padding': pageInfo()?.withPadding }"
  >
    @if (isBeadcrumb() === false) {}
    <app-breadcrumb />

    <router-outlet />
  </main>
  @if (isSidebarOpen()) {
    <div
      class="c-dashboard__overlay"
      (click)="isSidebarOpen.set(false)"
      [attr.aria-hidden]="true"
      (keyup)="(null)"
    ></div>
  }
</div>
